import React from 'react';
import { LayoutContext } from 'components/layouts/LayoutContext';

export function useScrollHandler(
  handleScroll: (e?: Event) => void,
  scrollRef?: React.RefObject<HTMLElement>,
) {
  React.useEffect(() => {
    const target = scrollRef?.current || window;
    target.addEventListener('scroll', handleScroll);
    return () => {
      target.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll, scrollRef]);
}

export function useLayoutScrollHandler(handleScroll: (e?: Event) => void) {
  const { layoutRef } = React.useContext(LayoutContext);
  return useScrollHandler(handleScroll, layoutRef);
}
